import { createContext as t } from "react";
const r = t();
class o {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(s) {
    s.forEach((e) => {
      this.usedNamespaces[e] || (this.usedNamespaces[e] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
export {
  r as I18nContext,
  o as ReportNamespaces
};
//# sourceMappingURL=help-center-knowledge-anatomies40.js.map
